import types from '../types'
import Action from '../../types/Action'

const initialState = {
  loading: true,
  error: false,
  success: false,
  data: []
}

const overnightCareReducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case types.GET_OVERNIGHT_CARE_REQUESTED: {
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
        data: []
      }
    }
    case types.GET_OVERNIGHT_CARE_FULFILLED: {
      return {
        ...state,
        loading: false,
        success: true,
        data: action.payload
      }
    }
    case types.GET_OVERNIGHT_CARE_REJECTED: {
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    }
    default: {
      return state
    }
  }
}

export default overnightCareReducer